import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/ubuntu/download_staging/6a687569a875aa001451d76b_1786465564510_82a37858/wearecircular/node_modules/next/dist/client/app-dir/link.js");
